import React, { useState } from "react";
import { usePrecandidateContext } from "../precandidate/context/Context";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useHistory } from "react-router-dom";
import { PreCandidateService } from "../../services/PreCandidate";
import { useTranslation } from "react-i18next";

const ModalAlertToCreateInterviewOrScreenCall = ({
  isOpen,
  setIsOpen,
  isInterview
}) => {
  const {
    setInterviewId,

    preCandidateId
  } = usePrecandidateContext();
  const [
    alertMessageToCreateInterview,
    setAlertMessageToCreateInterview
  ] = useState();
  let history = useHistory();
  function submitButtonAction(event, precandidateId) {
    event.stopPropagation();
    createInterview(precandidateId);
  }
  const { t } = useTranslation();
  function createInterview() {
    (async () => {
      const resultAlertMessage = await PreCandidateService.GetAlertMessageToCreateInterview(
        preCandidateId
      );

      const interviewId = await PreCandidateService.CreateInterviewOrScreenCall(
        preCandidateId,
        isInterview
      );

      if (resultAlertMessage.message === "") {
        history.push(`/interview/createOrEdit/${interviewId}`);
      } else {
        setInterviewId(interviewId);
        setAlertMessageToCreateInterview(resultAlertMessage.message);
      }
    })();
  }
  return (
    <ModalContainer
      modalTitle="Alert"
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      submitButtonAction={submitButtonAction}
      cancelButtonAction={() => setIsOpen(false)}
      cancelButtonTitle="Cancel"
      submitButtonTitle="Ok"
      submitButtonType="submit"
    >
      <div>
        {isInterview
          ? t(
              "An interview will be created for this candidate. The information generated in DocOnline for this pre-candidate will be passed on for the interview. Do you want to continue?"
            )
          : t(
              "An screen call will be created for this candidate. Do you want to continue?"
            )}

        {alertMessageToCreateInterview}
      </div>
    </ModalContainer>
  );
};

export default ModalAlertToCreateInterviewOrScreenCall;
